import React from 'react';
import { SectionHeadingProps } from '../types';
function SectionSubHeading(props: SectionHeadingProps) {
  return <h5 className="abt-subheading">{props.Heading}</h5>;
}
export default SectionSubHeading;
